import {
	Link,
	Outlet,
	useLoaderData,
	data,
	type LoaderFunctionArgs,
} from 'react-router'
import Footer from '#app/components/layout/Footer_Pap.tsx'
import Header from '#app/components/layout/Header_Pap.tsx'
import LogoCloud from '#app/components/layout/LogoCloud.tsx'
import { useCookieConsent, CookieBannerComponent, extractCookieConsent } from '#app/utils/pz/cookieBanner'
import { useTagManager } from '#app/utils/pz/tagManager'

interface EnvVariables {
	MODE?: 'production' | 'development' | 'test'
	SENTRY_DSN?: string
	ALLOW_INDEXING?: 'true' | 'false'
	TAG_MANAGER_ID?: string
}

export async function loader({ request }: LoaderFunctionArgs) {
	// Obtener las variables de entorno necesarias
	const env = (await import('../utils/env.server').then((m) =>
		m.getEnv(),
	)) as EnvVariables

	// Extraer el consentimiento de cookies usando la función utilitaria
	const consentGiven = extractCookieConsent(request)

	// Importar funciones de utilidad
	const { getDomainUrl, combineHeaders } = await import('../utils/misc')

	return data(
		{
			requestInfo: {
				origin: getDomainUrl(request),
				path: new URL(request.url).pathname,
			},
			ENV: env,
			consentGiven,
		},
		{
			headers: combineHeaders({}),
		},
	)
}

export default function AppLayout() {
	const loaderData = useLoaderData<typeof loader>()
	const ENV = loaderData?.ENV || ({} as EnvVariables)
	const initialConsent = loaderData?.consentGiven || false

	const { TAG_MANAGER_ID } = ENV

	// Usar los hooks personalizados para cookies y tag manager
	const { consentGiven, handleAccept, handleDecline } = useCookieConsent(initialConsent)
	useTagManager(TAG_MANAGER_ID, consentGiven)

	return (
		<>
			<div className="flex min-h-screen flex-col">
				<Header />
				<div className="container flex-1">
					<Outlet />
				</div>
			</div>
			<LogoCloud />
			<Footer />

			{/* Componente de consentimiento de cookies */}
			<CookieBannerComponent
				onAccept={handleAccept}
				onDecline={handleDecline}
			>
				Este sitio web utiliza cookies para mejorar la experiencia del usuario.
				Consulta nuestra{' '}
				<Link to="/legal" className="text-bold text-amber-700">
					Política de privacidad
				</Link>{' '}
				para obtener más información.
			</CookieBannerComponent>
		</>
	)
}

// Añadir la declaración para TypeScript
declare global {
	interface Window {
		dataLayer: any[]
	}
}
